import * as React from "react";

import { useDispatch, useSelector } from 'react-redux';
import { setAddress } from '../actions/registrationActions';
import AddressForm from './AddressForm';
import BasicButton from '../styleguide/BasicButton';
import DeliveryBlacklistMessage from './DeliveryBlacklistMessage';

import '../registration/MaterialUI.module.css';
import styles from './Address.module.css';

/**
 * Provide a form to edit the location-search selected address ( minus apartment number ) 
 */
const AddressUpdater = () => {
 
  const dispatch = useDispatch();

  // Existing values from redux
  const currentStreet = useSelector(state => state.street_address);
  const currentCity = useSelector(state => state.city);
  const currentState = useSelector(state => state.state);
  const currentZipCode = useSelector(state => state.zip_code);

  // Updated user entries from AddressForm
  const [streetAddress, setStreetAddress] = React.useState(currentStreet);
  const [city, setCity] = React.useState(currentCity);
  const [state, setState] = React.useState(currentState);
  const [zipCode, setZipCode] = React.useState(currentZipCode);
 
  //Show the edit form
  const [editAddress, setEditAddress] = React.useState(); 
  
  const editAddressClick = (event, isEdit) => {
    event && event.preventDefault();
    setEditAddress(isEdit);
  }

  const onAddressUpdate = (addressObj) => {
    dispatch(setAddress(addressObj));
    setStreetAddress(addressObj.street_address);
    setCity(addressObj.city);
    setState(addressObj.state);
    setZipCode(addressObj.zip_code);
    setEditAddress(false);
  }

  return (
    <div className={styles.addressForm}>
      { editAddress 
        ? <div className={styles.formWrap}> 
            <AddressForm 
              onAddressUpdate={onAddressUpdate}
              onCancel={() => setEditAddress(false)}
              /> 
          </div>
        : <div className={styles.addressWithEditButton}> 
            <div className={styles.formattedAddress}>
              {`${streetAddress}, ${city}, ${state} ${zipCode}`}    
            </div>
            <div className={styles.fauxLabel}>
              Address
            </div>   
            <BasicButton text="Edit" handleClick={(event) => editAddressClick(event,true)} />
        </div>
      }
      <DeliveryBlacklistMessage 
          street_address={streetAddress}
          city={city}
          state={state}
          zip_code={zipCode}
          onDarkBackground
        />
    </div>
  );
}

export default AddressUpdater;